import React, { useRef } from 'react';
import { PrintIcon } from '../../../utils/TableActionIcons';
import { handlePrintData } from '../../../utils/PrintData';
import { useSelector } from 'react-redux';

const FormsResultsPreviewTable = ({ selectedPatientFormData }) => {
  const printRef = useRef(null);
  const { buisnessInfo } = useSelector(state => state?.auth);
  return (
    <div>
      <div
        className='icon-bg-container absolute top-[21px] right-[70px]'
        onClick={() => handlePrintData(printRef.current?.innerHTML, 'HomeCareFormResult')}
      >
        <PrintIcon iconSize='20' />
      </div>
      <div className='result-main mb-2 print-container' ref={printRef}>
        <div className='text-center flex items-center flex-col pb-2'>
          <img className='h-[50px]' src={`data:image/png;base64,${buisnessInfo?.logo}`} />
          <p className='text-red-600 font-bold'>{buisnessInfo?.name_ar}</p>
        </div>
        <div className='grid grid-cols-12 gap-1 px-3 mt-4'>
          {selectedPatientFormData?.data?.header?.map((headerItem, index) => {
            const match = headerItem?.name_en?.match(/Col(\d+)/);
            const columnCount = match ? parseInt(match[1], 10) : 1;
            const colSpan = 12 / columnCount;
            if (headerItem?.elements) {
              return headerItem?.elements?.map((element, index) => (
                <React.Fragment key={index}>
                  {element.type === 'heading' ? (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='bg-gray-300 rounded p-2' key={index}>
                        <h1 className='text-16-gray !font-semibold'>{element?.name_en}</h1>
                      </div>
                    </div>
                  ) : (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='border border-gray-300 rounded flex justify-between items-center p-3' key={index}>
                        <label className='text-14-dark !font-semibold'>{element?.name_en}</label>
                        <span className='text-12-dark'>
                          {typeof element?.value?.value === 'string' &&
                          element?.value?.value?.includes('data:image/') ? (
                            <img
                              src={element?.value?.value}
                              alt='Signature or Uploaded Image'
                              className='w-[100px] h-[100px] rounded'
                            />
                          ) : (
                            element?.value?.value
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ));
            }
          })}
        </div>
        <div className='grid grid-cols-12 gap-1 px-3 mt-2'>
          {selectedPatientFormData?.data?.body?.map((bodyItem, index) => {
            const match = bodyItem?.name_en?.match(/Col(\d+)/);
            const columnCount = match ? parseInt(match[1], 10) : 1;
            const colSpan = 12 / columnCount;
            if (bodyItem?.elements) {
              return bodyItem?.elements?.map((element, index) => (
                <React.Fragment key={index}>
                  {element.type === 'heading' ? (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='bg-gray-300 print-bg-gray-300 rounded p-2' key={index}>
                        <h1 className='text-16-gray !font-semibold'>{element?.name_en}</h1>
                      </div>
                    </div>
                  ) : (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='border border-gray-300 rounded flex justify-between items-center p-3' key={index}>
                        <label className='text-14-dark !font-semibold'>{element?.name_en}</label>
                        <span className='text-12-dark'>
                          {typeof element?.value?.value === 'string' &&
                          element?.value?.value?.includes('data:image/') ? (
                            <img
                              src={element?.value?.value}
                              alt='Signature or Uploaded Image'
                              className='w-[100px] h-[100px] rounded'
                            />
                          ) : (
                            element?.value?.value
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ));
            }
          })}
        </div>
        <div className='px-3 grid grid-cols-12 gap-1 mt-2'>
          {selectedPatientFormData?.data?.footer?.map((footerItem, index) => {
            const match = footerItem?.name_en?.match(/Col(\d+)/);
            const columnCount = match ? parseInt(match[1], 10) : 1;
            const colSpan = 12 / columnCount;
            if (footerItem?.elements) {
              return footerItem?.elements?.map((element, index) => (
                <React.Fragment key={index}>
                  {element.type === 'heading' ? (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='bg-gray-300 rounded p-2' key={index}>
                        <h1 className='text-16-gray !font-semibold'>{element?.name_en}</h1>
                      </div>
                    </div>
                  ) : (
                    <div className={`col-span-${colSpan} p-0`}>
                      <div className='border border-gray-300 rounded flex justify-between items-center p-3' key={index}>
                        <label className='text-14-dark !font-semibold'>{element?.name_en}</label>
                        <span className='text-12-dark'>
                          {typeof element?.value?.value === 'string' &&
                          element?.value?.value?.includes('data:image/') ? (
                            <img
                              src={element?.value?.value}
                              alt='Signature or Uploaded Image'
                              className='w-[100px] h-[100px] rounded'
                            />
                          ) : (
                            element?.value?.value
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ));
            }
          })}
        </div>
      </div>
    </div>
  );
};

export default FormsResultsPreviewTable;
